var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentDemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8867 6H7.10894C5.88164 6 4.88672 6.99492 4.88672 8.22222V19.3333C4.88672 20.5606 5.88164 21.5556 7.10894 21.5556H24.8867C26.114 21.5556 27.1089 20.5606 27.1089 19.3333V8.22222C27.1089 6.99492 26.114 6 24.8867 6Z",
    stroke: "#0A80D5",
    strokeWidth: 2.22222,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 26H20.4436",
    stroke: "#0A80D5",
    strokeWidth: 2.22222,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5566V26.0011",
    stroke: "#0A80D5",
    strokeWidth: 2.22222,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19C18.7614 19 21 16.7614 21 14C21 11.2386 18.7614 9 16 9C13.2386 9 11 11.2386 11 14C11 16.7614 13.2386 19 16 19ZM15.8533 11.502H13.9283V16.5H15.8533C16.6047 16.5 17.209 16.2713 17.6663 15.814C18.1237 15.3567 18.3523 14.7523 18.3523 14.001C18.3523 13.2497 18.1237 12.6453 17.6663 12.188C17.209 11.7307 16.6047 11.502 15.8533 11.502ZM16.9943 12.699C17.265 13.007 17.4003 13.441 17.4003 14.001C17.4003 14.561 17.265 14.995 16.9943 15.303C16.7283 15.611 16.348 15.765 15.8533 15.765H14.8383V12.237H15.8533C16.348 12.237 16.7283 12.391 16.9943 12.699Z",
    fill: "#0A80D5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDemo);
export default __webpack_public_path__ + "static/media/student-demo.7ddb607d7253086626621f73f2c3ac6e.svg";
export { ForwardRef as ReactComponent };